import {
  DefaultButton,
  PrimaryButton,
  ProgressIndicator,
  Stack,
  makeStyles,
} from '@fluentui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DataAccessPolicyValues } from '../types';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    width: '100%',
    backgroundColor: theme.palette.neutralLighterAlt,
    zIndex: 99,
    bottom: 0,
    padding: '10px 20px',
    height: 84,
    marginTop: 40,
  },
  progressContainer: {
    height: 12,
  },
}));

interface FooterProps {
  loading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  loading,
  onSubmit,
  onCancel,
}) => {
  const styles = useStyles();
  const {
    formState: { isDirty, isValid },
  } = useFormContext<DataAccessPolicyValues>();
  const isDisabled = !isDirty || !isValid;

  return (
    <Stack className={styles.container}>
      <Stack tokens={{ childrenGap: 10 }}>
        <Stack className={styles.progressContainer}>
          {loading && <ProgressIndicator />}
        </Stack>
        <Stack
          horizontal
          tokens={{
            childrenGap: 20,
          }}
        >
          <PrimaryButton text="Save" onClick={onSubmit} disabled={isDisabled} />
          <DefaultButton text="Cancel" onClick={onCancel} />
        </Stack>
      </Stack>
    </Stack>
  );
};
